import type { Tool } from './types';

export const kundliMatching: Tool = {
  slug: 'kundli-matching',
  metaTitle: 'Kundli Matching by AI — Free Gun Milan & Ashtakoot Score',
  metaDescription:
    'Free AI Kundli matching for marriage: get your Ashtakoot Gun Milan score out of 36, Mangal Dosha check and a plain-language compatibility reading from an AI Vedic astrologer.',
  keywords:
    'kundli matching, kundli matching by ai, gun milan, guna milan, ashtakoot, horoscope matching for marriage, kundli milan',
  eyebrow: 'Marriage Compatibility',
  h1: 'Kundli Matching by AI (Gun Milan)',
  appName: 'KundaliAI Kundli Matching',
  calculator: 'kundli-matching',
  intro:
    'Match two birth charts the Vedic way. KundaliAI computes your Ashtakoot Gun Milan score out of 36, checks for Mangal Dosha on both sides, and explains what the score actually means for the relationship — in plain language, not just a number. Free to start.',
  ctaLabel: 'Match kundlis for free',
  ctaHref: '/chat',
  sections: [
    {
      heading: 'What is Gun Milan (Ashtakoot matching)?',
      body: 'Ashtakoot Gun Milan is the classical Vedic method of matching two horoscopes for marriage. It compares the Moon signs and Nakshatras of both partners across **eight kootas** (compatibility factors) — Varna, Vashya, Tara, Yoni, Graha Maitri, Gana, Bhakoot and Nadi — worth 36 points in total. A higher score suggests smoother compatibility, but the individual kootas and any doshas matter as much as the headline number.',
    },
    {
      heading: 'How to read your score',
      body: 'As a rough guide:\n\n- **Below 18** — considered a weak match by tradition; worth examining which kootas are low.\n- **18–24** — an acceptable match.\n- **25–32** — a very good match.\n- **33–36** — an excellent match.\n\nKundaliAI goes beyond the tally: it flags critical factors like **Nadi dosha** and **Bhakoot dosha**, checks **Mangal Dosha** for both charts, and explains whether cancellations apply — so you understand the real picture.',
    },
    {
      heading: 'Why AI matching helps',
      body: "A traditional report gives you a table of numbers. KundaliAI lets you **ask follow-up questions** — *'why is our Nadi score zero?'*, *'does his Mangal Dosha cancel?'*, *'what remedies help?'* — and answers using both charts, grounded in classical rules. It's the difference between a score sheet and a conversation with an astrologer.",
    },
  ],
  faq: [
    {
      question: 'How many gunas are needed for marriage?',
      answer:
        'Traditionally a score of 18 out of 36 or above is considered acceptable, and 25+ is considered a good match. However, low scores in critical kootas like Nadi or Bhakoot, or an unresolved Mangal Dosha, matter as much as the total.',
    },
    {
      question: 'Do I need both birth times for matching?',
      answer:
        'Gun Milan is based primarily on the Moon and Nakshatra, so dates and places are essential. Accurate birth times improve dosha checks and house-based analysis.',
    },
    {
      question: 'What is Nadi dosha?',
      answer:
        'Nadi dosha occurs when both partners share the same Nadi, and it carries the highest single weight (8 points) in Ashtakoot matching. KundaliAI checks whether recognized cancellation rules apply in your case.',
    },
    {
      question: 'Is Kundli matching free here?',
      answer:
        'Yes — you can run a match and ask questions for free to start. Premium plans unlock saved matches and detailed compatibility reports.',
    },
  ],
  related: [
    { label: 'Mangal Dosha calculator', href: '/mangal-dosha-calculator' },
    { label: 'Free Kundli by date of birth', href: '/free-kundli' },
    { label: 'Talk to an AI astrologer', href: '/ai-astrologer' },
  ],
};
